/* eslint-disable no-undef */

import React, { useEffect } from 'react';
import useStateRef from 'react-usestateref';
import { DarkButton } from '../../components/dark-button';
import { Modal } from 'react-bootstrap';
import { selectDocuments } from '../../redux/slices/documentSlice';
import { selectSession } from '../../redux/slices/sessionSlice';
import { toast } from 'react-toastify';
import { useAppSelector } from '../../redux/hook';
import useState from 'react-usestateref';
import { useTranslation } from 'react-i18next';

export default function LivenessVerificationHome({
	callback,
	skipLiveness,
	loaderModel,
	onError,
}) {
	const { t } = useTranslation();
	const [_, setShowSkipModal, showSkipModalRef] = useState(false);
	const { isFaceVerificationError } = useAppSelector(selectDocuments);
	const [__, setLoader, loader] = useState(loaderModel);
	const { multiTexts } = useAppSelector(selectSession);
	const [ShowFinishLoader, setFinishShowLoader] = useState(false);
	const [____, setButtonLoading, buttonLoadingRef] = useStateRef(false);
	const generalMsg = multiTexts?.find(
		(setting) => setting.textName === 'ProceedMsg'
	);

	const listener = (event) => {
		if (
			event.detail.action === 'PROCESS_FINISHED' &&
			event.detail.data.status === 1 &&
			event.detail.data.response.code === 0
		) {
			setLoader(false);
			callback(event.detail.data.response.images[0]);
		} else if (event.detail.action === 'RETRY_COUNTER_EXCEEDED') {
			setLoader(false);
			toast.info('Verification needs to be done in Hotel');
			skipLiveness();
		} else if (event.detail.action === 'ELEMENT_VISIBLE') {
			const style = getComputedStyle(document.body);
			const primaryColor = style.getPropertyValue('--primary-color');
			const component = document.getElementsByTagName('face-liveness')[0];
			component.settings = {
				closeDisabled: true,
				retryCount: 777,
				changeCamera: true,
				startScreen: true,
				customization: {
					onboardingScreenStartButtonBackground: primaryColor,
					onboardingScreenStartButtonBackgroundHover: primaryColor,
				},
			};
		} else {
			console.log('failed liveness');
			//const component = document.getElementsByTagName('face-liveness')[0];
			//component.parentNode.removeChild(component);

			//loadFaceLiveness();
			//callback(event);
			// component.settings = {
			// 	closeDisabled: true,
			// 	retryCount: 2,
			// 	changeCamera: true,
			// };
		}
		// ideally use toast
		// toast.error('Liveness check has failed. Please retry or contact customer support.');
	};

	function documentSkipCancel() {
		setShowSkipModal(false);
		setButtonLoading(false);
		setFinishShowLoader(true);
		console.log('######################', buttonLoadingRef);
	}

	useEffect(() => {
		if (ShowFinishLoader) {
			const timer = setTimeout(() => setFinishShowLoader(false), 100);
			return () => clearTimeout(timer);
		}
	}, [ShowFinishLoader]);

	useEffect(() => {
		// const defer = $.Deferred();
		// defer
		// 	.then(() => {
		// 		const component = '<face-liveness />';
		// 		$('#liveness-check-container').append(component);
		// 	})
		// 	.then(() => {
		// 		const scriptTag = $('<script src="face_main_full.js" />');
		// 		$('#liveness-check-container').append(scriptTag);
		// 	})
		// 	.then(() => {
		// 		const component = document.getElementsByTagName('face-liveness')[0];
		// 		component.settings = {
		// 			closeDisabled: true,
		// 			retryCount: 2,
		// 			changeCamera: true,
		// 		};
		// 		component.addEventListener('face-liveness', listener);
		// 	});

		// defer.resolve();

		loadFaceLiveness();
		//loadFaceLivenessSettings();
	}, []);

	const loadFaceLiveness = async () => {
		// Simulate asynchronous operations
		//await new Promise((resolve) => setTimeout(resolve, 1000));

		const scriptTag = document.createElement('script');
		scriptTag.src = 'face_main_full.js';
		document.getElementById('liveness-check-container')?.appendChild(scriptTag);

		const component = document.createElement('face-liveness');

		document.getElementById('liveness-check-container')?.appendChild(component);
		component.addEventListener('face-liveness', listener);
	};

	// useEffect(() => {
	// 	console.log('isFaceVerificationError ==' + isFaceVerificationError);
	// 	if (isFaceVerificationError === true) {
	// 		// const component = document.getElementsByTagName('face-liveness')[0];
	// 		// component.remove();
	// 		//window.location.reload();
	// 		// const component = document.getElementsByTagName('face-liveness')[0];
	// 		// if (component !== null && component !== undefined) {
	// 		// 	component?.parentNode?.removeChild(component);
	// 		// }

	// 		// loadFaceLiveness();
	// 		// setLoader(false);
	// 		onError();
	// 	}
	// }, [isFaceVerificationError]);

	return (
		<div
			className="d-flex flex-column gap-4 vh-100 mx-auto justify-content-between"
			style={{
				paddingBottom: '110px',
				overflow: 'auto',
				height: 'calc(100vh - 80px)',
				background: 'white',
			}}>
			<div className="d-flex flex-column gap-4 vh-100 mx-auto justify-content-between">
				<div
					className="theme-facial-recognition"
					id="liveness-check-container"
					style={{ overflow: 'auto', paddingBottom: '1px' }}></div>
				{/* <p className="text-center">
					Keep your head up and make sure your face fits into the circle. Remove
					Selfie Time!
				</p> */}
			</div>

			<div
				className="fixed-bottom w-100 px-5 pb-4 pt-1 border-top d-flex flex-row justify-content-center theme-footer"
				style={{ backgroundColor: 'white', borderColor: 'gray' }}>
				<DarkButton
					text={t('FacialPageButtonSkip')}
					hideArrow
					onClick={() => {
						setShowSkipModal(true);
						setButtonLoading(false);
					}}
					// onClick={() => setShowSkipModal(true)}
					// override
					override={ShowFinishLoader}
				/>
			</div>
			<Modal
				centered
				backdrop={true}
				show={showSkipModalRef.current}
				onHide={() => setShowSkipModal(false)}
				contentClassName="skip-modal-content">
				<Modal.Body>
					<p
						className="p-2 text-center m-0 lh-sm"
						style={{ fontSize: '0.9rem' }}>
						{/* Please complete the check-in process by presenting your ID at the
						hotel reception. */}
						{generalMsg ? (
							<>{generalMsg?.textValue}</>
						) : (
							<>
								{t(
									'Please complete the check-in process by uploading the ID at the hotel Kiosk'
								)}
							</>
						)}
					</p>
				</Modal.Body>
				<Modal.Footer
					className="p-0"
					style={{
						borderTop: '2px solid #c0c5c5',
					}}>
					<div className="d-flex flex-row justify-content-center w-100 m-0 fw-bold">
						<button
							id="btn-pagejsx-cancel"
							className="w-50 p-2 text-center"
							style={{
								all: 'unset',
								borderRight: '1px solid #c0c5c5',
								color: '#f2675e',
								cursor: 'pointer',
							}}
							onClick={() => {
								// setShowSkipModal(false)
								documentSkipCancel();
							}}>
							Cancel
						</button>
						<button
							id="btn-pagejsx-ok"
							className="w-50 p-2 text-center"
							style={{ all: 'unset', color: '#3892f3', cursor: 'pointer' }}
							onClick={skipLiveness}>
							OK
						</button>
					</div>
				</Modal.Footer>
			</Modal>
			<Modal
				centered
				backdrop={true}
				show={loader.current}
				onHide={() => setLoader(false)}
				contentClassName="skip-modal-content">
				<Modal.Body>
					<p
						className="p-2 text-center m-0 lh-sm"
						style={{ fontSize: '0.9rem' }}>
						{t('Please Wait')}
					</p>
					<div className="spinner-grow my-auto" role="status" />
				</Modal.Body>
			</Modal>
		</div>
	);
}
